export const textLineClamp = (lines = 2) => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  textAlign: 'center',
});

export const dataGridCellAlignmentSx = {
  '& .MuiDataGrid-cell:has(> *), & .MuiDataGrid-row--dynamicHeight > .MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 'inherit',
  },
} as const;

export const dataGridProSx = {
  border: 'none',
  '--unstable_DataGrid-radius': '0',
  '& .MuiDataGrid-withBorderColor': {
    border: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    border: '1px solid rgba(0, 83, 55, 0.20)',
    backgroundColor: 'background.lightGreen',
    '&:not(:first-of-type)': {
      borderLeft: 'none',
    },
    '&:last-of-type': {
      width: '100% !important',
      maxWidth: 'unset !important',
    },
  },
  '& .MuiDataGrid-columnHeadersInner': {
    width: '100%',
    '> div': {
      width: '100%',
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
  },
  '& .MuiDataGrid-row:nth-of-type(even)': {
    backgroundColor: 'background.light',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  '& .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-footerContainer': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator': {
    visibility: 'hidden',
  },
  '& .MuiDataGrid-cellContent': textLineClamp(),
  '& .MuiDataGrid-detailPanel': {
    backgroundColor: 'background.lighter',
  },
} as const;
